
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsBrandDialog extends Serenity.EntityDialog<CsBrandRow, any> {
        protected getFormKey() { return CsBrandForm.formKey; }
        // protected getIsActiveProperty() { return CsBrandRow.isActiveProperty; }
        protected getIdProperty() { return CsBrandRow.idProperty; }
        protected getLocalTextPrefix() { return CsBrandRow.localTextPrefix; }
        protected getNameProperty() { return CsBrandRow.nameProperty; }
        protected getService() { return CsBrandService.baseUrl; }
        protected getDeletePermission() { return CsBrandRow.deletePermission; }
        protected getInsertPermission() { return CsBrandRow.insertPermission; }
        protected getUpdatePermission() { return CsBrandRow.updatePermission; }

        protected form = new CsBrandForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Brandid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.BrandCode == this.entity.BrandCode);
            if(Brandid != null){
                // this.deleteButton.toggleClass('disabled', true);
                this.toolbar.findButton("delete-button").hide();
                
            }
        }
        
    }
}